export default {
    ServerUrl: 'http://localhost:3000',
    ApiUrl: 'http://localhost:3000/api/v1',
    client_id: 'GBz3tcl0ERaDnUuaYkbNUSkP',
    redirect_uri: 'http://localhost:8080',
}


// WEBPACK FOOTER //
// ./src/config/dev.js